import { render, staticRenderFns } from "./ResetPassword.vue?vue&type=template&id=c3f9229e&scoped=true&"
import script from "./ResetPassword.vue?vue&type=script&lang=js&"
export * from "./ResetPassword.vue?vue&type=script&lang=js&"
import style0 from "./ResetPassword.vue?vue&type=style&index=0&id=c3f9229e&lang=scss&"
import style1 from "./ResetPassword.vue?vue&type=style&index=1&id=c3f9229e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3f9229e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/chuongdev/Desktop/project/333QLK_FE/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c3f9229e')) {
      api.createRecord('c3f9229e', component.options)
    } else {
      api.reload('c3f9229e', component.options)
    }
    module.hot.accept("./ResetPassword.vue?vue&type=template&id=c3f9229e&scoped=true&", function () {
      api.rerender('c3f9229e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/login/components/ResetPassword.vue"
export default component.exports